import { ElMessage } from 'element-plus'
import useClipboard from 'vue-clipboard3'
import { UAParser } from 'ua-parser-js'
import { xhSet, xhGet } from './xhCookie'
import qs from 'qs'

const uaParser = UAParser(navigator.userAgent)
// 获得系统版本（PC-0，iOS-1，Android-2）
export const getSystem = () => {
  let system = 'Other'
  if (uaParser.os.name === 'iOS') {
    system = 'iOS'
  } else if (uaParser.os.name === 'Android') {
    system = 'android'
  } else if (uaParser.ua.toUpperCase().includes('HARMONYOS')) {
    system = 'harmonyos'
  }
  return system
}

// 手机格式校验
export const PhoneCheck = (phone) => {
  // 定义手机号码的正则表达式规则
  var regExp = /^1[3456789]\d{9}$/
  if (regExp.test(phone)) {
    return true // 符合手机号码格式要求
  } else {
    return false // 不符合手机号码格式要求
  }
}

// 判断是否首次进入页面
// 0为假 1为真
export const firstPage = () => {
  if (!xhGet('XH-WEB')?.isRefresh) {
    // 首次进入
    xhSet('XH-WEB', { isRefresh: 1 })
    return true
  } else if (xhGet('XH-WEB')?.isRefresh == 1) {
    // 刷新页面，非首次进入
    xhSet('XH-WEB', { isRefresh: 0 })
    return false
  }
}

// 解析URL參數
export const parseUrl = (link) => {
  return qs.parse(link.split('?')[1])
}

export const os = () => {
  // 开发环境下，测试IOS设备用（http://localhost:19000/m?ios=true）
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('ios')) {
    return 2
  }
  const system = getSystem()
  switch (system) {
    case 'iOS':
      return 2
    case 'harmonyos':
    case 'android':
      return 1
    default:
      return 3
  }
}
// 判断前端类型
export const client = () => {
  if (
    uaParser.device.type === 'mobile' ||
    uaParser.device.type === 'tablet' ||
    uaParser.device.type === 'wearable' ||
    uaParser.device.type === 'xr'
  ) {
    // wap
    return '2'
  } else {
    // pc
    return '1'
  }
}

export const deviceType = () => {
  if (os() == 3) {
    return 'pc'
  } else {
    return 'wap'
  }
}

export const Storage = {
  set: (key, data) => {
    localStorage.setItem(key, JSON.stringify(data))
  },
  get: (key) => {
    return JSON.parse(localStorage.getItem(key))
  },
}

// 删除接口错误提示括号内容数字
export const removeBracketContent = (str) => {
  return str.replace(/\[.*?\]/g, '')
}

const { toClipboard } = useClipboard()
// 复制文本
export const copy = async (val) => {
  try {
    await toClipboard(val)
    return ElMessage({
      message: '复制成功',
      center: true,
      offset: 200,
      type: 'success',
      customClass: 'ElMessageIndex',
    })
    // eslint-disable-next-line no-unused-vars
  } catch (_e) {
    return ElMessage({
      message: '复制失败',
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
  }
}

// 检测网页拉到底部
export const bottomScroll = () => {
  var windowHeight = window.innerHeight
  var body = document.body
  var html = document.documentElement
  var documentHeight = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight,
  )
  var scrollableDistance = documentHeight - windowHeight
  var scrolledDistance =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body).scrollTop

  if (scrollableDistance - scrolledDistance <= 1) {
    return true
  }
}
